import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';

@Injectable()
export class AbstractService {

	public apiPath = "";
	public userGuideUrlAY = "";

	constructor(protected http: HttpClient) {
		this.getEnvironment();
	}

	async getEnvironment(): Promise<void> {
		const jsonFile = `assets/config/config.json`;
		try {
			const response = await this.http.get<any>(jsonFile).toPromise();
			if (document.URL.search('localhost') !== -1) {
				this.apiPath = response.ApiUrl;
			} else if (document.URL.search('fvp.swine.solutions-d') !== -1) {
				this.apiPath = response.DevApiUrl;
			} else if (document.URL.search('fvp.swine.solutions-q') !== -1 ) {
				this.apiPath = response.QaApiUrl;
			} else {
				this.apiPath = response.ProdApiUrl;
			}
			this.userGuideUrlAY = this.apiPath + "getAttrLiteUserGuid";
		} catch (err) {
			console.error('Error reading JSON file: ', err);
		}
	}
}